module.exports = __webpack_public_path__ + "assets/img/delete-social-login-warning.2457a6e6.svg";